export default {
  posts: `Postagens`,
  about: `Sobre`,
  contact: `Contato`
}



// WEBPACK FOOTER //
// ./src/lang/zh/categories.js